<template>
  <div class="col-12 col-md-12 col-lg-10 text-center">
    <div class="tit">
      <p>Declaração de endividamento assinado pelo contador contendo: instituição, limite, modalidade, garantias, saldo, devedor, data inicial, data final, valor da PMT</p>
    </div>
    <form>
      <div class="margin">
        <files-input :files="arquivos" :accept="formatosAceitos"
          :uploadEndpoint="uploadEndpoint" @files-changed="onFilesChanged"/>
      </div>
      <div class="text-center fixedOptions">
        <button @click="onSubmit" class="btn btn-lg btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
  .margin {
    margin-bottom: 25px;
  }

  p.files {
    font-size: 12px!important;
    padding: 20px 0;
  }
</style>

<script>
import FilesInput from '@/components/FilesInput'
import ArrayHelper from '@/utils/array-helper'

export default {
  components: {
    FilesInput
  },
  data() {
    return {
      /* eslint-disable */  
      uploadEndpoint: process.env.API_NODE+'/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: this.solicitacao.ArquivosDeclaracaoEndividamento || []
    }
  },
  computed: {
    arquivosRecebidos: function() {
      return this.arquivos.filter(arquivo => {
        return arquivo != null && arquivo != undefined
      })
    }
  },
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles
    },
    validate() {
      if(this.arquivosRecebidos.length > 0) {
        return {isValid: true, errors: []}
      } else {
        return {isValid: false, errors: ['O envio da declaração de endividamento é obrigatório']}
      }
    },
    onSubmit(e) {
      e.preventDefault()
      const validation = this.validate()
      
      if(validation.isValid) {
        const newData = {
          ArquivosDeclaracaoEndividamento: this.arquivosRecebidos
        }
        this.$emit('on-submit', newData)
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: ArrayHelper.toSentence(validation.errors)})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/EnvioDeclaracaoEndividamentoPasso.vue